import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  actions: {
    display: 'flex',
    gap: '12px',
  },
  tooltip: {
    marginTop: '4px',
  },
  settingsControl: {
    padding: '8px 12px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    display: 'flex',
    borderRadius: '8px',
    ':hover': {
      background: 'var(--background-brand-ghost, #F8F6F2)',
    },
  },
  exportControl: {
    padding: '8px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    display: 'flex',
    borderRadius: anatomy.borderRadiusS,
    ':hover': {
      background: colors.hoverBackground,
    },
  },
});
